import { useGetFlightReports } from 'api-hooks/report';
import useDefaultValuesReportDate from 'hooks/use-default-values-report-date';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function FlightReport() {
  const { t } = useTranslation();

  const defaultFilters = useDefaultValuesReportDate('flight');

  return (
    <PivotReportTemplate
      title={t('common:flight_report')}
      usePivotQuery={useGetFlightReports}
      completeName={['customer', 'admin', 'guest', 'status']}
      defaultFilters={defaultFilters}
    />
  );
}
